<template>
  <div class="pt-60 pb-24">
    <div class="text-left container mx-auto">
      <h1 class="custom-heading h-custom-color">Podmínky opakovaných plateb</h1>
      <p class="p-custom-color custom-paragraph mr-20">
        Poslední aktualizace 18. 10. 2026
      </p>

      <p class="mt-20">
        Tyto podmínky upravují opakované platby za služby společnosti HostNow s.r.o.,
        IČO: 21788693, DIČ: CZ21788693, se sídlem Třeboňská 530/2, 140 00 Praha 4 - Michle, Česká republika.
      </p>

      <h1 class="custom-heading h-custom-color mt-20">Souhlas s opakovanými platbami</h1>
      <ol class="list-decimal ml-10">
        <li>
          Opakované platby slouží k úhradě měsíčního předplatného hostingového
          plánu pro projekt zvolený zákazníkem v objednávce. První platbu zákazník
          provede kartou prostřednictvím platební brány GoPay. Další platby
          iniciuje HostNow po skončení každého uhrazeného měsíčního období.
        </li>
        <li>
          Zaškrtnutím políčka „Souhlasím s podmínkami opakovaných plateb“ zákazník
          výslovně souhlasí se založením opakované platby, s parametry uvedenými
          na této stránce a s uložením platebních údajů v systému GoPay.
        </li>
        <li>
          GoPay neposkytuje společnosti HostNow celé číslo platební karty ani její
          bezpečnostní údaje a HostNow k nim nemá přístup. GoPay zpracovává údaje
          karty podle bezpečnostního standardu PCI DSS Level 1.
        </li>
        <li>
          Po úspěšném založení opakované platby zašle HostNow zákazníkovi potvrzení
          na e-mailovou adresu jeho účtu, nejpozději do dvou pracovních dnů.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">Parametry opakované platby</h1>
      <ol class="list-decimal ml-10">
        <li>
          <strong>Důvod platby:</strong> měsíční předplatné zvoleného hostingového
          plánu pro konkrétní projekt.
        </li>
        <li>
          <strong>Výše platby:</strong> částka je variabilní podle aktuální ceny
          zvoleného plánu, fakturační země, platné sazby DPH a platnosti DIČ pro DPH.
          Jednou opakovanou platbou může HostNow strhnout nejvýše 500 EUR nebo
          12 500 CZK včetně DPH.
        </li>
        <li>
          <strong>Frekvence:</strong> měsíčně po skončení uhrazeného období.
          Přesný den může být variabilní podle zpracování platby a lhůty potřebné
          k oznámení změny.
        </li>
        <li>
          <strong>Doba platnosti oprávnění:</strong> pět let od udělení souhlasu
          nebo do jeho dřívějšího zrušení.
        </li>
        <li>
          <strong>Oznámení změny:</strong> změnu částky nebo jiného parametru
          oznámí HostNow zákazníkovi e-mailem nejméně sedm pracovních dnů před
          provedením platby. Zákazník může před provedením změněné platby
          opakované platby zrušit.
        </li>
      </ol>

      <h1 class="custom-heading h-custom-color mt-20">Změna a zrušení</h1>
      <ol class="list-decimal ml-10">
        <li>
          Zákazník může požádat o změnu nastavení prostřednictvím ticketového
          systému v administračním rozhraní nebo e-mailem na
          <a class="text-blue-800 hover:underline" href="mailto:info@hostnow.cz">info@hostnow.cz</a>.
        </li>
        <li>
          Opakované platby může zákazník kdykoli zrušit přechodem projektu na
          bezplatný plán nebo odstraněním projektu v administračním rozhraní.
          Zrušení zastaví budoucí platby. Přechod na bezplatný plán je okamžitý
          a nevyužitá část již uhrazeného období se nevrací, ledaže zákazníkovi
          právo na vrácení peněz přiznává zákon nebo
          <router-link class="text-blue-800 hover:underline" to="/vseobecne-obchodne-podmienky">
            všeobecné obchodní podmínky
          </router-link>.
        </li>
        <li>
          Zrušení oprávnění nemá vliv na platby řádně provedené před jeho zrušením
          ani na povinnost uhradit již poskytnuté služby.
        </li>
        <li>
          Záznam oprávnění a jeho parametry uchovává HostNow po dobu jeho platnosti
          a nejméně dvanáct měsíců po ukončení opakovaných plateb. Následně jej
          uchovává pouze po dobu potřebnou k ochraně právních nároků nebo splnění
          právní povinnosti. Nezbytné údaje, které jsou součástí daňových a platebních
          záznamů, se uchovávají deset let od konce příslušného zdaňovacího období.
          Podrobnosti stanoví
          <router-link class="text-blue-800 hover:underline" to="/podmienky-ochrany-sukromia">
            zásady ochrany osobních údajů
          </router-link>.
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecurringPaymentTerms",
  mounted () {
    window.scrollTo(0, 0)
  },
  metaInfo() {
    return {title: "Podmínky opakovaných plateb"}
  },
}
</script>

<style scoped>
</style>
